import { LineItem } from '@commercelayer/sdk';
import { FC } from 'react';

import { InputSpinner } from '@components/atoms/InputSpinner';

type Props = {
  lineItem: LineItem;
  quantity: number;
  handleChange: any;
};

export const QuantitySelector: FC<Props> = ({ lineItem, quantity, handleChange }) => {
  return (
    <div className="relative w-full">
      <InputSpinner
        quantity={quantity}
        handleChange={handleChange}
        debounceMs={0}
        availability={getItemInventoryQuantity(lineItem)}
      />
    </div>
  );
};

function getItemInventoryQuantity(lineItem?: LineItem): number | undefined {
  const maxQuantity = lineItem.metadata?.maxQuantity;
  if (maxQuantity) {
    return maxQuantity;
  }
  const item = lineItem?.item;
  if (item == null) {
    return undefined;
  }

  if ('inventory' in item && item.inventory?.quantity != null) {
    return item.inventory.quantity;
  }

  return undefined;
}
